// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios, { AxiosResponse } from 'axios';
import { newServer } from 'constants/constants';


// Tipos para los recursos de traducción
interface TranslationDictionary {
  [key: string]: string;
}

interface ResourceLanguage {
  translation: { [key: string]: string };
}

interface Resources {
  [language: string]: {
    translation: { [key: string]: string };
  };
}

// Inicialización con recursos temporales (opcional, mientras carga)
const temporaryResources: Resources = {
  en: {
    translation: {
      loading: 'Loading translations...'
    }
  }
};

// Función para cargar los recursos desde el backend
const loadTranslationsFromBackend = async (): Promise<Resources> => {
  try {
    const response: AxiosResponse<Resources> = await axios.get(`${newServer}languages-directory/translations/resources`);
    return response.data;
  } catch (error) {
    console.error('Error al cargar traducciones del backend:', error);
    // En caso de error, podríamos devolver recursos por defecto o mostrar un mensaje de error
    return temporaryResources;
  }
};

// Inicializar i18next con recursos temporales
i18n.use(initReactI18next).init({
  resources: temporaryResources,
  lng: navigator.language.split('-')[0], // se toma el idioma del navegador, por ejemplo "es" o "en"
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

// Cargar y actualizar los recursos desde el backend
loadTranslationsFromBackend()
  .then((resources: Resources) => {
    // Actualizar los recursos con los obtenidos del backend
    Object.keys(resources).forEach((language: string) => {
      i18n.addResourceBundle(
        language,
        'translation',
        resources[language].translation || {},
        true,
        true
      );
    });
    
    // Recargar la página actual con las nuevas traducciones
    if (i18n.isInitialized) {
      i18n.reloadResources();
    }
    
    console.log('Traducciones cargadas correctamente desde el backend');
  })
  .catch((error: Error) => {
    console.error('Error al inicializar traducciones:', error);
  });

// Interfaz para la respuesta de importación
interface ImportResponse {
  message: string;
  summary: {
    languages_added: number;
    keys_added: number;
    translations_added: number;
  };
  details: {
    languages_directory: string[];
    keys: string[];
    translations: string[];
  };
}

// Si necesitas exportar la función para importar traducciones (por ejemplo, para el panel de administración)
export const importTranslations = async (resources: Resources): Promise<ImportResponse> => {
  try {
    const response: AxiosResponse<ImportResponse> = await axios.post(
      `${newServer}languages-directory/translations/import`, 
      { resources }
    );
    console.log('Traducciones importadas correctamente:', response.data);
    
    // Actualizar i18n con las nuevas traducciones después de importarlas
    await loadTranslationsFromBackend()
      .then((updatedResources: Resources) => {
        Object.keys(updatedResources).forEach((language: string) => {
          i18n.addResourceBundle(
            language,
            'translation',
            updatedResources[language].translation || {},
            true,
            true
          );
        });
        
        if (i18n.isInitialized) {
          i18n.reloadResources();
        }
      });
      
    return response.data;
  } catch (error) {
    console.error('Error al importar traducciones:', error);
    throw error;
  }
};

export default i18n;